import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as checks from "./checks.js";
import * as core from "./core.js";
import { Doc } from "./doc.js";
import { parse, parseAsync, safeParse, safeParseAsync } from "./parse.js";
import * as regexes from "./regexes.js";
import * as util from "./util.js";
import { version } from "./versions.js";
export const $ZodType = /*@__PURE__*/core.$constructor("$ZodType", (inst, def) => {
  var _inst, _inst$_zod$def$checks;
  var _a;
  (_inst = inst) !== null && _inst !== void 0 ? _inst : inst = {};
  inst._zod.def = def; // set _def property
  inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
  inst._zod.version = version;
  const checks = [...((_inst$_zod$def$checks = inst._zod.def.checks) !== null && _inst$_zod$def$checks !== void 0 ? _inst$_zod$def$checks : [])];
  // if inst is itself a checks.$ZodCheck, run it as a check
  if (inst._zod.traits.has("$ZodCheck")) {
    checks.unshift(inst);
  }
  for (const ch of checks) {
    for (const fn of ch._zod.onattach) {
      fn(inst);
    }
  }
  if (checks.length === 0) {
    var _a$deferred, _inst$_zod$deferred;
    // deferred initializer
    // inst._zod.parse is not yet defined
    (_a$deferred = (_a = inst._zod).deferred) !== null && _a$deferred !== void 0 ? _a$deferred : _a.deferred = [];
    (_inst$_zod$deferred = inst._zod.deferred) === null || _inst$_zod$deferred === void 0 || _inst$_zod$deferred.push(() => {
      inst._zod.run = inst._zod.parse;
    });
  } else {
    const runChecks = (payload, checks, ctx) => {
      let isAborted = util.aborted(payload);
      let asyncResult;
      for (const ch of checks) {
        if (ch._zod.def.when) {
          const shouldRun = ch._zod.def.when(payload);
          if (!shouldRun) continue;
        } else if (isAborted) {
          continue;
        }
        const currLen = payload.issues.length;
        const _ = ch._zod.check(payload);
        if (_ instanceof Promise && (ctx === null || ctx === void 0 ? void 0 : ctx.async) === false) {
          throw new core.$ZodAsyncError();
        }
        if (asyncResult || _ instanceof Promise) {
          var _asyncResult;
          asyncResult = ((_asyncResult = asyncResult) !== null && _asyncResult !== void 0 ? _asyncResult : Promise.resolve()).then(async () => {
            await _;
            const nextLen = payload.issues.length;
            if (nextLen === currLen) return;
            if (!isAborted) isAborted = util.aborted(payload, currLen);
          });
        } else {
          const nextLen = payload.issues.length;
          if (nextLen === currLen) continue;
          if (!isAborted) isAborted = util.aborted(payload, currLen);
        }
      }
      if (asyncResult) {
        return asyncResult.then(() => {
          return payload;
        });
      }
      return payload;
    };
    // const handleChecksResult = (
    //   checkResult: ParsePayload,
    //   originalResult: ParsePayload,
    //   ctx: ParseContextInternal
    // ): util.MaybeAsync<ParsePayload> => {
    //   // if the checks mutated the value && there are no issues, re-parse the result
    //   if (checkResult.value !== originalResult.value && !checkResult.issues.length)
    //     return inst._zod.parse(checkResult, ctx);
    //   return originalResult;
    // };
    const handleCanaryResult = (canary, payload, ctx) => {
      // abort if the canary is aborted
      if (util.aborted(canary)) {
        canary.aborted = true;
        return canary;
      }
      // run checks first, then
      const checkResult = runChecks(payload, checks, ctx);
      if (checkResult instanceof Promise) {
        if (ctx.async === false) throw new core.$ZodAsyncError();
        return checkResult.then(checkResult => inst._zod.parse(checkResult, ctx));
      }
      return inst._zod.parse(checkResult, ctx);
    };
    inst._zod.run = (payload, ctx) => {
      if (ctx.skipChecks) {
        return inst._zod.parse(payload, ctx);
      }
      if (ctx.direction === "backward") {
        // run canary
        // initial pass (no checks)
        const canary = inst._zod.parse({
          value: payload.value,
          issues: []
        }, _objectSpread(_objectSpread({}, ctx), {}, {
          skipChecks: true
        }));
        if (canary instanceof Promise) {
          return canary.then(canary => {
            return handleCanaryResult(canary, payload, ctx);
          });
        }
        return handleCanaryResult(canary, payload, ctx);
      }
      // forward
      const result = inst._zod.parse(payload, ctx);
      if (result instanceof Promise) {
        if (ctx.async === false) throw new core.$ZodAsyncError();
        return result.then(result => runChecks(result, checks, ctx));
      }
      return runChecks(result, checks, ctx);
    };
  }
  inst["~standard"] = {
    validate: value => {
      try {
        var _r$error;
        const r = safeParse(inst, value);
        return r.success ? {
          value: r.data
        } : {
          issues: (_r$error = r.error) === null || _r$error === void 0 ? void 0 : _r$error.issues
        };
      } catch (_) {
        return safeParseAsync(inst, value).then(r => {
          var _r$error2;
          return r.success ? {
            value: r.data
          } : {
            issues: (_r$error2 = r.error) === null || _r$error2 === void 0 ? void 0 : _r$error2.issues
          };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
});
export { clone } from "./util.js";
export const $ZodString = /*@__PURE__*/core.$constructor("$ZodString", (inst, def) => {
  var _pop, _inst$_zod$bag$patter, _inst$_zod$bag;
  $ZodType.init(inst, def);
  inst._zod.pattern = (_pop = [...((_inst$_zod$bag$patter = inst === null || inst === void 0 || (_inst$_zod$bag = inst._zod.bag) === null || _inst$_zod$bag === void 0 ? void 0 : _inst$_zod$bag.patterns) !== null && _inst$_zod$bag$patter !== void 0 ? _inst$_zod$bag$patter : [])].pop()) !== null && _pop !== void 0 ? _pop : regexes.string(inst._zod.bag);
  inst._zod.parse = (payload, _) => {
    if (def.coerce) try {
      payload.value = String(payload.value);
    } catch (_) {}
    if (typeof payload.value === "string") return payload;
    payload.issues.push({
      expected: "string",
      code: "invalid_type",
      input: payload.value,
      inst
    });
    return payload;
  };
});
export const $ZodStringFormat = /*@__PURE__*/core.$constructor("$ZodStringFormat", (inst, def) => {
  // check initialization must come first
  checks.$ZodCheckStringFormat.init(inst, def);
  $ZodString.init(inst, def);
});
export const $ZodGUID = /*@__PURE__*/core.$constructor("$ZodGUID", (inst, def) => {
  var _def$pattern;
  (_def$pattern = def.pattern) !== null && _def$pattern !== void 0 ? _def$pattern : def.pattern = regexes.guid;
  $ZodStringFormat.init(inst, def);
});
export const $ZodUUID = /*@__PURE__*/core.$constructor("$ZodUUID", (inst, def) => {
  var _def$pattern3;
  if (def.version) {
    var _def$pattern2;
    const versionMap = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    };
    const v = versionMap[def.version];
    if (v === undefined) throw new Error("Invalid UUID version: \"".concat(def.version, "\""));
    (_def$pattern2 = def.pattern) !== null && _def$pattern2 !== void 0 ? _def$pattern2 : def.pattern = regexes.uuid(v);
  } else (_def$pattern3 = def.pattern) !== null && _def$pattern3 !== void 0 ? _def$pattern3 : def.pattern = regexes.uuid();
  $ZodStringFormat.init(inst, def);
});
export const $ZodEmail = /*@__PURE__*/core.$constructor("$ZodEmail", (inst, def) => {
  var _def$pattern4;
  (_def$pattern4 = def.pattern) !== null && _def$pattern4 !== void 0 ? _def$pattern4 : def.pattern = regexes.email;
  $ZodStringFormat.init(inst, def);
});
export const $ZodURL = /*@__PURE__*/core.$constructor("$ZodURL", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  inst._zod.check = payload => {
    try {
      // Trim whitespace from input
      const trimmed = payload.value.trim();
      // @ts-ignore
      const url = new URL(trimmed);
      if (def.hostname) {
        def.hostname.lastIndex = 0;
        if (!def.hostname.test(url.hostname)) {
          payload.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid hostname",
            pattern: regexes.hostname.source,
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      }
      if (def.protocol) {
        def.protocol.lastIndex = 0;
        if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) {
          payload.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid protocol",
            pattern: def.protocol.source,
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      }
      // Set the output value based on normalize flag
      if (def.normalize) {
        // Use normalized URL
        payload.value = url.href;
      } else {
        // Preserve the original input (trimmed)
        payload.value = trimmed;
      }
      return;
    } catch (_) {
      payload.issues.push({
        code: "invalid_format",
        format: "url",
        input: payload.value,
        inst,
        continue: !def.abort
      });
    }
  };
});
export const $ZodEmoji = /*@__PURE__*/core.$constructor("$ZodEmoji", (inst, def) => {
  var _def$pattern5;
  (_def$pattern5 = def.pattern) !== null && _def$pattern5 !== void 0 ? _def$pattern5 : def.pattern = regexes.emoji();
  $ZodStringFormat.init(inst, def);
});
export const $ZodNanoID = /*@__PURE__*/core.$constructor("$ZodNanoID", (inst, def) => {
  var _def$pattern6;
  (_def$pattern6 = def.pattern) !== null && _def$pattern6 !== void 0 ? _def$pattern6 : def.pattern = regexes.nanoid;
  $ZodStringFormat.init(inst, def);
});
export const $ZodCUID = /*@__PURE__*/core.$constructor("$ZodCUID", (inst, def) => {
  var _def$pattern7;
  (_def$pattern7 = def.pattern) !== null && _def$pattern7 !== void 0 ? _def$pattern7 : def.pattern = regexes.cuid;
  $ZodStringFormat.init(inst, def);
});
export const $ZodCUID2 = /*@__PURE__*/core.$constructor("$ZodCUID2", (inst, def) => {
  var _def$pattern8;
  (_def$pattern8 = def.pattern) !== null && _def$pattern8 !== void 0 ? _def$pattern8 : def.pattern = regexes.cuid2;
  $ZodStringFormat.init(inst, def);
});
export const $ZodULID = /*@__PURE__*/core.$constructor("$ZodULID", (inst, def) => {
  var _def$pattern9;
  (_def$pattern9 = def.pattern) !== null && _def$pattern9 !== void 0 ? _def$pattern9 : def.pattern = regexes.ulid;
  $ZodStringFormat.init(inst, def);
});
export const $ZodXID = /*@__PURE__*/core.$constructor("$ZodXID", (inst, def) => {
  var _def$pattern10;
  (_def$pattern10 = def.pattern) !== null && _def$pattern10 !== void 0 ? _def$pattern10 : def.pattern = regexes.xid;
  $ZodStringFormat.init(inst, def);
});
export const $ZodKSUID = /*@__PURE__*/core.$constructor("$ZodKSUID", (inst, def) => {
  var _def$pattern11;
  (_def$pattern11 = def.pattern) !== null && _def$pattern11 !== void 0 ? _def$pattern11 : def.pattern = regexes.ksuid;
  $ZodStringFormat.init(inst, def);
});
export const $ZodISODateTime = /*@__PURE__*/core.$constructor("$ZodISODateTime", (inst, def) => {
  var _def$pattern12;
  (_def$pattern12 = def.pattern) !== null && _def$pattern12 !== void 0 ? _def$pattern12 : def.pattern = regexes.datetime(def);
  $ZodStringFormat.init(inst, def);
});
export const $ZodISODate = /*@__PURE__*/core.$constructor("$ZodISODate", (inst, def) => {
  var _def$pattern13;
  (_def$pattern13 = def.pattern) !== null && _def$pattern13 !== void 0 ? _def$pattern13 : def.pattern = regexes.date;
  $ZodStringFormat.init(inst, def);
});
export const $ZodISOTime = /*@__PURE__*/core.$constructor("$ZodISOTime", (inst, def) => {
  var _def$pattern14;
  (_def$pattern14 = def.pattern) !== null && _def$pattern14 !== void 0 ? _def$pattern14 : def.pattern = regexes.time(def);
  $ZodStringFormat.init(inst, def);
});
export const $ZodISODuration = /*@__PURE__*/core.$constructor("$ZodISODuration", (inst, def) => {
  var _def$pattern15;
  (_def$pattern15 = def.pattern) !== null && _def$pattern15 !== void 0 ? _def$pattern15 : def.pattern = regexes.duration;
  $ZodStringFormat.init(inst, def);
});
export const $ZodIPv4 = /*@__PURE__*/core.$constructor("$ZodIPv4", (inst, def) => {
  var _def$pattern16;
  (_def$pattern16 = def.pattern) !== null && _def$pattern16 !== void 0 ? _def$pattern16 : def.pattern = regexes.ipv4;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push(inst => {
    const bag = inst._zod.bag;
    bag.format = "ipv4";
  });
});
export const $ZodIPv6 = /*@__PURE__*/core.$constructor("$ZodIPv6", (inst, def) => {
  var _def$pattern17;
  (_def$pattern17 = def.pattern) !== null && _def$pattern17 !== void 0 ? _def$pattern17 : def.pattern = regexes.ipv6;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push(inst => {
    const bag = inst._zod.bag;
    bag.format = "ipv6";
  });
  inst._zod.check = payload => {
    try {
      // @ts-ignore
      new URL("http://[".concat(payload.value, "]"));
      // return;
    } catch (_unused) {
      payload.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: payload.value,
        inst,
        continue: !def.abort
      });
    }
  };
});
export const $ZodCIDRv4 = /*@__PURE__*/core.$constructor("$ZodCIDRv4", (inst, def) => {
  var _def$pattern18;
  (_def$pattern18 = def.pattern) !== null && _def$pattern18 !== void 0 ? _def$pattern18 : def.pattern = regexes.cidrv4;
  $ZodStringFormat.init(inst, def);
});
export const $ZodCIDRv6 = /*@__PURE__*/core.$constructor("$ZodCIDRv6", (inst, def) => {
  var _def$pattern19;
  (_def$pattern19 = def.pattern) !== null && _def$pattern19 !== void 0 ? _def$pattern19 : def.pattern = regexes.cidrv6; // not used for validation
  $ZodStringFormat.init(inst, def);
  inst._zod.check = payload => {
    const parts = payload.value.split("/");
    try {
      if (parts.length !== 2) throw new Error();
      const [address, prefix] = parts;
      if (!prefix) throw new Error();
      const prefixNum = Number(prefix);
      if ("".concat(prefixNum) !== prefix) throw new Error();
      if (prefixNum < 0 || prefixNum > 128) throw new Error();
      // @ts-ignore
      new URL("http://[".concat(address, "]"));
    } catch (_unused2) {
      payload.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: payload.value,
        inst,
        continue: !def.abort
      });
    }
  };
});
//////////////////////////////   ZodBase64   //////////////////////////////
export function isValidBase64(data) {
  if (data === "") return true;
  if (data.length % 4 !== 0) return false;
  try {
    // @ts-ignore
    atob(data);
    return true;
  } catch (_unused3) {
    return false;
  }
}
export const $ZodBase64 = /*@__PURE__*/core.$constructor("$ZodBase64", (inst, def) => {
  var _def$pattern20;
  (_def$pattern20 = def.pattern) !== null && _def$pattern20 !== void 0 ? _def$pattern20 : def.pattern = regexes.base64;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push(inst => {
    inst._zod.bag.contentEncoding = "base64";
  });
  inst._zod.check = payload => {
    if (isValidBase64(payload.value)) return;
    payload.issues.push({
      code: "invalid_format",
      format: "base64",
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
//////////////////////////////   ZodBase64   //////////////////////////////
export function isValidBase64URL(data) {
  if (!regexes.base64url.test(data)) return false;
  const base64 = data.replace(/[-_]/g, c => c === "-" ? "+" : "/");
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
  return isValidBase64(padded);
}
export const $ZodBase64URL = /*@__PURE__*/core.$constructor("$ZodBase64URL", (inst, def) => {
  var _def$pattern21;
  (_def$pattern21 = def.pattern) !== null && _def$pattern21 !== void 0 ? _def$pattern21 : def.pattern = regexes.base64url;
  $ZodStringFormat.init(inst, def);
  inst._zod.onattach.push(inst => {
    inst._zod.bag.contentEncoding = "base64url";
  });
  inst._zod.check = payload => {
    if (isValidBase64URL(payload.value)) return;
    payload.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
export const $ZodE164 = /*@__PURE__*/core.$constructor("$ZodE164", (inst, def) => {
  var _def$pattern22;
  (_def$pattern22 = def.pattern) !== null && _def$pattern22 !== void 0 ? _def$pattern22 : def.pattern = regexes.e164;
  $ZodStringFormat.init(inst, def);
});
//////////////////////////////   ZodJWT   //////////////////////////////
export function isValidJWT(token) {
  let algorithm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  try {
    const tokensParts = token.split(".");
    if (tokensParts.length !== 3) return false;
    const [header] = tokensParts;
    if (!header) return false;
    // @ts-ignore
    const parsedHeader = JSON.parse(atob(header));
    if ("typ" in parsedHeader && (parsedHeader === null || parsedHeader === void 0 ? void 0 : parsedHeader.typ) !== "JWT") return false;
    if (!parsedHeader.alg) return false;
    if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
    return true;
  } catch (_unused4) {
    return false;
  }
}
export const $ZodJWT = /*@__PURE__*/core.$constructor("$ZodJWT", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  inst._zod.check = payload => {
    if (isValidJWT(payload.value, def.alg)) return;
    payload.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
export const $ZodCustomStringFormat = /*@__PURE__*/core.$constructor("$ZodCustomStringFormat", (inst, def) => {
  $ZodStringFormat.init(inst, def);
  inst._zod.check = payload => {
    if (def.fn(payload.value)) return;
    payload.issues.push({
      code: "invalid_format",
      format: def.format,
      input: payload.value,
      inst,
      continue: !def.abort
    });
  };
});
export const $ZodNumber = /*@__PURE__*/core.$constructor("$ZodNumber", (inst, def) => {
  var _inst$_zod$bag$patter2;
  $ZodType.init(inst, def);
  inst._zod.pattern = (_inst$_zod$bag$patter2 = inst._zod.bag.pattern) !== null && _inst$_zod$bag$patter2 !== void 0 ? _inst$_zod$bag$patter2 : regexes.number;
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce) try {
      payload.value = Number(payload.value);
    } catch (_) {}
    const input = payload.value;
    if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) {
      return payload;
    }
    const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : undefined : undefined;
    payload.issues.push(_objectSpread({
      expected: "number",
      code: "invalid_type",
      input,
      inst
    }, received ? {
      received
    } : {}));
    return payload;
  };
});
export const $ZodNumberFormat = /*@__PURE__*/core.$constructor("$ZodNumber", (inst, def) => {
  checks.$ZodCheckNumberFormat.init(inst, def);
  $ZodNumber.init(inst, def); // no format checksp
});
export const $ZodBoolean = /*@__PURE__*/core.$constructor("$ZodBoolean", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = regexes.boolean;
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce) try {
      payload.value = Boolean(payload.value);
    } catch (_) {}
    const input = payload.value;
    if (typeof input === "boolean") return payload;
    payload.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
export const $ZodBigInt = /*@__PURE__*/core.$constructor("$ZodBigInt", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = regexes.bigint;
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce) try {
      payload.value = BigInt(payload.value);
    } catch (_) {}
    if (typeof payload.value === "bigint") return payload;
    payload.issues.push({
      expected: "bigint",
      code: "invalid_type",
      input: payload.value,
      inst
    });
    return payload;
  };
});
export const $ZodBigIntFormat = /*@__PURE__*/core.$constructor("$ZodBigInt", (inst, def) => {
  checks.$ZodCheckBigIntFormat.init(inst, def);
  $ZodBigInt.init(inst, def); // no format checks
});
export const $ZodSymbol = /*@__PURE__*/core.$constructor("$ZodSymbol", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (typeof input === "symbol") return payload;
    payload.issues.push({
      expected: "symbol",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
export const $ZodUndefined = /*@__PURE__*/core.$constructor("$ZodUndefined", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = regexes.undefined;
  inst._zod.values = new Set([undefined]);
  inst._zod.optin = "optional";
  inst._zod.optout = "optional";
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (typeof input === "undefined") return payload;
    payload.issues.push({
      expected: "undefined",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
export const $ZodNull = /*@__PURE__*/core.$constructor("$ZodNull", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.pattern = regexes.null;
  inst._zod.values = new Set([null]);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (input === null) return payload;
    payload.issues.push({
      expected: "null",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
export const $ZodAny = /*@__PURE__*/core.$constructor("$ZodAny", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = payload => payload;
});
export const $ZodUnknown = /*@__PURE__*/core.$constructor("$ZodUnknown", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = payload => payload;
});
export const $ZodNever = /*@__PURE__*/core.$constructor("$ZodNever", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    payload.issues.push({
      expected: "never",
      code: "invalid_type",
      input: payload.value,
      inst
    });
    return payload;
  };
});
export const $ZodVoid = /*@__PURE__*/core.$constructor("$ZodVoid", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (typeof input === "undefined") return payload;
    payload.issues.push({
      expected: "void",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
export const $ZodDate = /*@__PURE__*/core.$constructor("$ZodDate", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    if (def.coerce) {
      try {
        payload.value = new Date(payload.value);
      } catch (_err) {}
    }
    const input = payload.value;
    const isDate = input instanceof Date;
    const isValidDate = isDate && !Number.isNaN(input.getTime());
    if (isValidDate) return payload;
    payload.issues.push(_objectSpread(_objectSpread({
      expected: "date",
      code: "invalid_type",
      input
    }, isDate ? {
      received: "Invalid Date"
    } : {}), {}, {
      inst
    }));
    return payload;
  };
});
function handleArrayResult(result, final, index) {
  if (result.issues.length) {
    final.issues.push(...util.prefixIssues(index, result.issues));
  }
  final.value[index] = result.value;
}
export const $ZodArray = /*@__PURE__*/core.$constructor("$ZodArray", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!Array.isArray(input)) {
      payload.issues.push({
        expected: "array",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    payload.value = Array(input.length);
    const proms = [];
    for (let i = 0; i < input.length; i++) {
      const item = input[i];
      const result = def.element._zod.run({
        value: item,
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        proms.push(result.then(result => handleArrayResult(result, payload, i)));
      } else {
        handleArrayResult(result, payload, i);
      }
    }
    if (proms.length) {
      return Promise.all(proms).then(() => payload);
    }
    return payload; //handleArrayResultsAsync(parseResults, final);
  };
});
function handlePropertyResult(result, final, key, input) {
  if (result.issues.length) {
    final.issues.push(...util.prefixIssues(key, result.issues));
  }
  if (result.value === undefined) {
    if (key in input) {
      final.value[key] = undefined;
    }
  } else {
    final.value[key] = result.value;
  }
}
function normalizeDef(def) {
  const keys = Object.keys(def.shape);
  for (const k of keys) {
    var _def$shape;
    if (!((_def$shape = def.shape) !== null && _def$shape !== void 0 && (_def$shape = _def$shape[k]) !== null && _def$shape !== void 0 && (_def$shape = _def$shape._zod) !== null && _def$shape !== void 0 && (_def$shape = _def$shape.traits) !== null && _def$shape !== void 0 && _def$shape.has("$ZodType"))) {
      throw new Error("Invalid element at key \"".concat(k, "\": expected a Zod schema"));
    }
  }
  const okeys = util.optionalKeys(def.shape);
  return _objectSpread(_objectSpread({}, def), {}, {
    keys,
    keySet: new Set(keys),
    numKeys: keys.length,
    optionalKeys: new Set(okeys)
  });
}
function handleCatchall(proms, input, payload, ctx, def, inst) {
  const unrecognized = [];
  // iterate over input keys
  const keySet = def.keySet;
  const _catchall = def.catchall._zod;
  const t = _catchall.def.type;
  for (const key of Object.keys(input)) {
    if (keySet.has(key)) continue;
    if (t === "never") {
      unrecognized.push(key);
      continue;
    }
    const r = _catchall.run({
      value: input[key],
      issues: []
    }, ctx);
    if (r instanceof Promise) {
      proms.push(r.then(r => handlePropertyResult(r, payload, key, input)));
    } else {
      handlePropertyResult(r, payload, key, input);
    }
  }
  if (unrecognized.length) {
    payload.issues.push({
      code: "unrecognized_keys",
      keys: unrecognized,
      input,
      inst
    });
  }
  if (!proms.length) return payload;
  return Promise.all(proms).then(() => {
    return payload;
  });
}
export const $ZodObject = /*@__PURE__*/core.$constructor("$ZodObject", (inst, def) => {
  // requires cast because technically $ZodObject doesn't extend
  $ZodType.init(inst, def);
  // const sh = def.shape;
  const desc = Object.getOwnPropertyDescriptor(def, "shape");
  if (!(desc !== null && desc !== void 0 && desc.get)) {
    const sh = def.shape;
    Object.defineProperty(def, "shape", {
      get: () => {
        const newSh = _objectSpread({}, sh);
        Object.defineProperty(def, "shape", {
          value: newSh
        });
        return newSh;
      }
    });
  }
  const _normalized = util.cached(() => normalizeDef(def));
  util.defineLazy(inst._zod, "propValues", () => {
    const shape = def.shape;
    const propValues = {};
    for (const key in shape) {
      const field = shape[key]._zod;
      if (field.values) {
        var _propValues$key;
        (_propValues$key = propValues[key]) !== null && _propValues$key !== void 0 ? _propValues$key : propValues[key] = new Set();
        for (const v of field.values) propValues[key].add(v);
      }
    }
    return propValues;
  });
  const isObject = util.isObject;
  const catchall = def.catchall;
  let value;
  inst._zod.parse = (payload, ctx) => {
    var _value;
    (_value = value) !== null && _value !== void 0 ? _value : value = _normalized.value;
    const input = payload.value;
    if (!isObject(input)) {
      payload.issues.push({
        expected: "object",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    payload.value = {};
    const proms = [];
    const shape = value.shape;
    for (const key of value.keys) {
      const el = shape[key];
      const r = el._zod.run({
        value: input[key],
        issues: []
      }, ctx);
      if (r instanceof Promise) {
        proms.push(r.then(r => handlePropertyResult(r, payload, key, input)));
      } else {
        handlePropertyResult(r, payload, key, input);
      }
    }
    if (!catchall) {
      return proms.length ? Promise.all(proms).then(() => payload) : payload;
    }
    return handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
  };
});
export const $ZodObjectJIT = /*@__PURE__*/core.$constructor("$ZodObjectJIT", (inst, def) => {
  // requires cast because technically $ZodObject doesn't extend
  $ZodObject.init(inst, def);
  const superParse = inst._zod.parse;
  const _normalized = util.cached(() => normalizeDef(def));
  const generateFastpass = shape => {
    const doc = new Doc(["shape", "payload", "ctx"]);
    const normalized = _normalized.value;
    const parseStr = key => {
      const k = util.esc(key);
      return "shape[".concat(k, "]._zod.run({ value: input[").concat(k, "], issues: [] }, ctx)");
    };
    doc.write("const input = payload.value;");
    const ids = Object.create(null);
    let counter = 0;
    for (const key of normalized.keys) {
      ids[key] = "key_".concat(counter++);
    }
    // A: preserve key order {
    doc.write("const newResult = {};");
    for (const key of normalized.keys) {
      const id = ids[key];
      const k = util.esc(key);
      doc.write("const ".concat(id, " = ").concat(parseStr(key), ";"));
      doc.write("\n        if (".concat(id, ".issues.length) {\n          payload.issues = payload.issues.concat(").concat(id, ".issues.map(iss => ({\n            ...iss,\n            path: iss.path ? [").concat(k, ", ...iss.path] : [").concat(k, "]\n          })));\n        }\n        \n        \n        if (").concat(id, ".value === undefined) {\n          if (").concat(k, " in input) {\n            newResult[").concat(k, "] = undefined;\n          }\n        } else {\n          newResult[").concat(k, "] = ").concat(id, ".value;\n        }\n        \n      "));
    }
    doc.write("payload.value = newResult;");
    doc.write("return payload;");
    const fn = doc.compile();
    return (payload, ctx) => fn(shape, payload, ctx);
  };
  let fastpass;
  const isObject = util.isObject;
  const jit = !core.globalConfig.jitless;
  const allowsEval = util.allowsEval;
  const fastEnabled = jit && allowsEval.value; // && !def.catchall;
  const catchall = def.catchall;
  let value;
  inst._zod.parse = (payload, ctx) => {
    var _value2;
    (_value2 = value) !== null && _value2 !== void 0 ? _value2 : value = _normalized.value;
    const input = payload.value;
    if (!isObject(input)) {
      payload.issues.push({
        expected: "object",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    if (jit && fastEnabled && (ctx === null || ctx === void 0 ? void 0 : ctx.async) === false && ctx.jitless !== true) {
      // always synchronous
      if (!fastpass) fastpass = generateFastpass(def.shape);
      payload = fastpass(payload, ctx);
      if (!catchall) return payload;
      return handleCatchall([], input, payload, ctx, value, inst);
    }
    return superParse(payload, ctx);
  };
});
function handleUnionResults(results, final, inst, ctx) {
  for (const result of results) {
    if (result.issues.length === 0) {
      final.value = result.value;
      return final;
    }
  }
  const nonaborted = results.filter(r => !util.aborted(r));
  if (nonaborted.length === 1) {
    final.value = nonaborted[0].value;
    return nonaborted[0];
  }
  final.issues.push({
    code: "invalid_union",
    input: final.value,
    inst,
    errors: results.map(result => result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config())))
  });
  return final;
}
export const $ZodUnion = /*@__PURE__*/core.$constructor("$ZodUnion", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "optin", () => def.options.some(o => o._zod.optin === "optional") ? "optional" : undefined);
  util.defineLazy(inst._zod, "optout", () => def.options.some(o => o._zod.optout === "optional") ? "optional" : undefined);
  util.defineLazy(inst._zod, "values", () => {
    if (def.options.every(o => o._zod.values)) {
      return new Set(def.options.flatMap(option => Array.from(option._zod.values)));
    }
    return undefined;
  });
  util.defineLazy(inst._zod, "pattern", () => {
    if (def.options.every(o => o._zod.pattern)) {
      const patterns = def.options.map(o => o._zod.pattern);
      return new RegExp("^(".concat(patterns.map(p => util.cleanRegex(p.source)).join("|"), ")$"));
    }
    return undefined;
  });
  const single = def.options.length === 1;
  const first = def.options[0]._zod.run;
  inst._zod.parse = (payload, ctx) => {
    if (single) {
      return first(payload, ctx);
    }
    let async = false;
    const results = [];
    for (const option of def.options) {
      const result = option._zod.run({
        value: payload.value,
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        results.push(result);
        async = true;
      } else {
        if (result.issues.length === 0) return result;
        results.push(result);
      }
    }
    if (!async) return handleUnionResults(results, payload, inst, ctx);
    return Promise.all(results).then(results => {
      return handleUnionResults(results, payload, inst, ctx);
    });
  };
});
export const $ZodDiscriminatedUnion = /*@__PURE__*/
core.$constructor("$ZodDiscriminatedUnion", (inst, def) => {
  $ZodUnion.init(inst, def);
  const _super = inst._zod.parse;
  util.defineLazy(inst._zod, "propValues", () => {
    const propValues = {};
    for (const option of def.options) {
      const pv = option._zod.propValues;
      if (!pv || Object.keys(pv).length === 0) throw new Error("Invalid discriminated union option at index \"".concat(def.options.indexOf(option), "\""));
      for (const [k, v] of Object.entries(pv)) {
        if (!propValues[k]) propValues[k] = new Set();
        for (const val of v) {
          propValues[k].add(val);
        }
      }
    }
    return propValues;
  });
  const disc = util.cached(() => {
    const opts = def.options;
    const map = new Map();
    for (const o of opts) {
      var _o$_zod$propValues;
      const values = (_o$_zod$propValues = o._zod.propValues) === null || _o$_zod$propValues === void 0 ? void 0 : _o$_zod$propValues[def.discriminator];
      if (!values || values.size === 0) throw new Error("Invalid discriminated union option at index \"".concat(def.options.indexOf(o), "\""));
      for (const v of values) {
        if (map.has(v)) {
          throw new Error("Duplicate discriminator value \"".concat(String(v), "\""));
        }
        map.set(v, o);
      }
    }
    return map;
  });
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!util.isObject(input)) {
      payload.issues.push({
        code: "invalid_type",
        expected: "object",
        input,
        inst
      });
      return payload;
    }
    const opt = disc.value.get(input === null || input === void 0 ? void 0 : input[def.discriminator]);
    if (opt) {
      return opt._zod.run(payload, ctx);
    }
    if (def.unionFallback) {
      return _super(payload, ctx);
    }
    // no matching discriminator
    payload.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: def.discriminator,
      input,
      path: [def.discriminator],
      inst
    });
    return payload;
  };
});
export const $ZodIntersection = /*@__PURE__*/core.$constructor("$ZodIntersection", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    const left = def.left._zod.run({
      value: input,
      issues: []
    }, ctx);
    const right = def.right._zod.run({
      value: input,
      issues: []
    }, ctx);
    const async = left instanceof Promise || right instanceof Promise;
    if (async) {
      return Promise.all([left, right]).then(_ref => {
        let [left, right] = _ref;
        return handleIntersectionResults(payload, left, right);
      });
    }
    return handleIntersectionResults(payload, left, right);
  };
});
function mergeValues(a, b) {
  // const aType = parse.t(a);
  // const bType = parse.t(b);
  if (a === b) {
    return {
      valid: true,
      data: a
    };
  }
  if (a instanceof Date && b instanceof Date && +a === +b) {
    return {
      valid: true,
      data: a
    };
  }
  if (util.isPlainObject(a) && util.isPlainObject(b)) {
    const bKeys = Object.keys(b);
    const sharedKeys = Object.keys(a).filter(key => bKeys.indexOf(key) !== -1);
    const newObj = _objectSpread(_objectSpread({}, a), b);
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return {
          valid: false,
          mergeErrorPath: [key, ...sharedValue.mergeErrorPath]
        };
      }
      newObj[key] = sharedValue.data;
    }
    return {
      valid: true,
      data: newObj
    };
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return {
        valid: false,
        mergeErrorPath: []
      };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return {
          valid: false,
          mergeErrorPath: [index, ...sharedValue.mergeErrorPath]
        };
      }
      newArray.push(sharedValue.data);
    }
    return {
      valid: true,
      data: newArray
    };
  }
  return {
    valid: false,
    mergeErrorPath: []
  };
}
function handleIntersectionResults(result, left, right) {
  if (left.issues.length) {
    result.issues.push(...left.issues);
  }
  if (right.issues.length) {
    result.issues.push(...right.issues);
  }
  if (util.aborted(result)) return result;
  const merged = mergeValues(left.value, right.value);
  if (!merged.valid) {
    throw new Error("Unmergable intersection. Error path: " + "".concat(JSON.stringify(merged.mergeErrorPath)));
  }
  result.value = merged.data;
  return result;
}
export const $ZodTuple = /*@__PURE__*/core.$constructor("$ZodTuple", (inst, def) => {
  $ZodType.init(inst, def);
  const items = def.items;
  const optStart = items.length - [...items].reverse().findIndex(item => item._zod.optin !== "optional");
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!Array.isArray(input)) {
      payload.issues.push({
        input,
        inst,
        expected: "tuple",
        code: "invalid_type"
      });
      return payload;
    }
    payload.value = [];
    const proms = [];
    if (!def.rest) {
      const tooBig = input.length > items.length;
      const tooSmall = input.length < optStart - 1;
      if (tooBig || tooSmall) {
        payload.issues.push(_objectSpread(_objectSpread({}, tooBig ? {
          code: "too_big",
          maximum: items.length
        } : {
          code: "too_small",
          minimum: items.length
        }), {}, {
          input,
          inst,
          origin: "array"
        }));
        return payload;
      }
    }
    let i = -1;
    for (const item of items) {
      i++;
      if (i >= input.length) if (i >= optStart) continue;
      const result = item._zod.run({
        value: input[i],
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        proms.push(result.then(result => handleTupleResult(result, payload, i)));
      } else {
        handleTupleResult(result, payload, i);
      }
    }
    if (def.rest) {
      const rest = input.slice(items.length);
      for (const el of rest) {
        i++;
        const result = def.rest._zod.run({
          value: el,
          issues: []
        }, ctx);
        if (result instanceof Promise) {
          proms.push(result.then(result => handleTupleResult(result, payload, i)));
        } else {
          handleTupleResult(result, payload, i);
        }
      }
    }
    if (proms.length) return Promise.all(proms).then(() => payload);
    return payload;
  };
});
function handleTupleResult(result, final, index) {
  if (result.issues.length) {
    final.issues.push(...util.prefixIssues(index, result.issues));
  }
  final.value[index] = result.value;
}
export const $ZodRecord = /*@__PURE__*/core.$constructor("$ZodRecord", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!util.isPlainObject(input)) {
      payload.issues.push({
        expected: "record",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    const proms = [];
    if (def.keyType._zod.values) {
      const values = def.keyType._zod.values;
      payload.value = {};
      for (const key of values) {
        if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
          const result = def.valueType._zod.run({
            value: input[key],
            issues: []
          }, ctx);
          if (result instanceof Promise) {
            proms.push(result.then(result => {
              if (result.issues.length) {
                payload.issues.push(...util.prefixIssues(key, result.issues));
              }
              payload.value[key] = result.value;
            }));
          } else {
            if (result.issues.length) {
              payload.issues.push(...util.prefixIssues(key, result.issues));
            }
            payload.value[key] = result.value;
          }
        }
      }
      let unrecognized;
      for (const key in input) {
        if (!values.has(key)) {
          var _unrecognized;
          unrecognized = (_unrecognized = unrecognized) !== null && _unrecognized !== void 0 ? _unrecognized : [];
          unrecognized.push(key);
        }
      }
      if (unrecognized && unrecognized.length > 0) {
        payload.issues.push({
          code: "unrecognized_keys",
          input,
          inst,
          keys: unrecognized
        });
      }
    } else {
      payload.value = {};
      for (const key of Reflect.ownKeys(input)) {
        if (key === "__proto__") continue;
        const keyResult = def.keyType._zod.run({
          value: key,
          issues: []
        }, ctx);
        if (keyResult instanceof Promise) {
          throw new Error("Async schemas not supported in object keys currently");
        }
        if (keyResult.issues.length) {
          payload.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: keyResult.issues.map(iss => util.finalizeIssue(iss, ctx, core.config())),
            input: key,
            path: [key],
            inst
          });
          payload.value[keyResult.value] = keyResult.value;
          continue;
        }
        const result = def.valueType._zod.run({
          value: input[key],
          issues: []
        }, ctx);
        if (result instanceof Promise) {
          proms.push(result.then(result => {
            if (result.issues.length) {
              payload.issues.push(...util.prefixIssues(key, result.issues));
            }
            payload.value[keyResult.value] = result.value;
          }));
        } else {
          if (result.issues.length) {
            payload.issues.push(...util.prefixIssues(key, result.issues));
          }
          payload.value[keyResult.value] = result.value;
        }
      }
    }
    if (proms.length) {
      return Promise.all(proms).then(() => payload);
    }
    return payload;
  };
});
export const $ZodMap = /*@__PURE__*/core.$constructor("$ZodMap", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!(input instanceof Map)) {
      payload.issues.push({
        expected: "map",
        code: "invalid_type",
        input,
        inst
      });
      return payload;
    }
    const proms = [];
    payload.value = new Map();
    for (const [key, value] of input) {
      const keyResult = def.keyType._zod.run({
        value: key,
        issues: []
      }, ctx);
      const valueResult = def.valueType._zod.run({
        value: value,
        issues: []
      }, ctx);
      if (keyResult instanceof Promise || valueResult instanceof Promise) {
        proms.push(Promise.all([keyResult, valueResult]).then(_ref2 => {
          let [keyResult, valueResult] = _ref2;
          handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }));
      } else {
        handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
      }
    }
    if (proms.length) return Promise.all(proms).then(() => payload);
    return payload;
  };
});
function handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
  if (keyResult.issues.length) {
    if (util.propertyKeyTypes.has(typeof key)) {
      final.issues.push(...util.prefixIssues(key, keyResult.issues));
    } else {
      final.issues.push({
        code: "invalid_key",
        origin: "map",
        input,
        inst,
        issues: keyResult.issues.map(iss => util.finalizeIssue(iss, ctx, core.config()))
      });
    }
  }
  if (valueResult.issues.length) {
    if (util.propertyKeyTypes.has(typeof key)) {
      final.issues.push(...util.prefixIssues(key, valueResult.issues));
    } else {
      final.issues.push({
        origin: "map",
        code: "invalid_element",
        input,
        inst,
        key: key,
        issues: valueResult.issues.map(iss => util.finalizeIssue(iss, ctx, core.config()))
      });
    }
  }
  final.value.set(keyResult.value, valueResult.value);
}
export const $ZodSet = /*@__PURE__*/core.$constructor("$ZodSet", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    const input = payload.value;
    if (!(input instanceof Set)) {
      payload.issues.push({
        input,
        inst,
        expected: "set",
        code: "invalid_type"
      });
      return payload;
    }
    const proms = [];
    payload.value = new Set();
    for (const item of input) {
      const result = def.valueType._zod.run({
        value: item,
        issues: []
      }, ctx);
      if (result instanceof Promise) {
        proms.push(result.then(result => handleSetResult(result, payload)));
      } else handleSetResult(result, payload);
    }
    if (proms.length) return Promise.all(proms).then(() => payload);
    return payload;
  };
});
function handleSetResult(result, final) {
  if (result.issues.length) {
    final.issues.push(...result.issues);
  }
  final.value.add(result.value);
}
export const $ZodEnum = /*@__PURE__*/core.$constructor("$ZodEnum", (inst, def) => {
  $ZodType.init(inst, def);
  const values = util.getEnumValues(def.entries);
  const valuesSet = new Set(values);
  inst._zod.values = valuesSet;
  inst._zod.pattern = new RegExp("^(".concat(values.filter(k => util.propertyKeyTypes.has(typeof k)).map(o => typeof o === "string" ? util.escapeRegex(o) : o.toString()).join("|"), ")$"));
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (valuesSet.has(input)) {
      return payload;
    }
    payload.issues.push({
      code: "invalid_value",
      values,
      input,
      inst
    });
    return payload;
  };
});
export const $ZodLiteral = /*@__PURE__*/core.$constructor("$ZodLiteral", (inst, def) => {
  $ZodType.init(inst, def);
  if (def.values.length === 0) {
    throw new Error("Cannot create literal schema with no valid values");
  }
  inst._zod.values = new Set(def.values);
  inst._zod.pattern = new RegExp("^(".concat(def.values.map(o => typeof o === "string" ? util.escapeRegex(o) : o ? util.escapeRegex(o.toString()) : String(o)).join("|"), ")$"));
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    if (inst._zod.values.has(input)) {
      return payload;
    }
    payload.issues.push({
      code: "invalid_value",
      values: def.values,
      input,
      inst
    });
    return payload;
  };
});
export const $ZodFile = /*@__PURE__*/core.$constructor("$ZodFile", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    const input = payload.value;
    // @ts-ignore
    if (input instanceof File) return payload;
    payload.issues.push({
      expected: "file",
      code: "invalid_type",
      input,
      inst
    });
    return payload;
  };
});
export const $ZodTransform = /*@__PURE__*/core.$constructor("$ZodTransform", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      throw new core.$ZodEncodeError(inst.constructor.name);
    }
    const _out = def.transform(payload.value, payload);
    if (ctx.async) {
      const output = _out instanceof Promise ? _out : Promise.resolve(_out);
      return output.then(output => {
        payload.value = output;
        return payload;
      });
    }
    if (_out instanceof Promise) {
      throw new core.$ZodAsyncError();
    }
    payload.value = _out;
    return payload;
  };
});
function handleOptionalResult(result, input) {
  if (result.issues.length && input === undefined) {
    return {
      issues: [],
      value: undefined
    };
  }
  return result;
}
export const $ZodOptional = /*@__PURE__*/core.$constructor("$ZodOptional", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.optin = "optional";
  inst._zod.optout = "optional";
  util.defineLazy(inst._zod, "values", () => {
    return def.innerType._zod.values ? new Set([...def.innerType._zod.values, undefined]) : undefined;
  });
  util.defineLazy(inst._zod, "pattern", () => {
    const pattern = def.innerType._zod.pattern;
    return pattern ? new RegExp("^(".concat(util.cleanRegex(pattern.source), ")?$")) : undefined;
  });
  inst._zod.parse = (payload, ctx) => {
    if (def.innerType._zod.optin === "optional") {
      const result = def.innerType._zod.run(payload, ctx);
      if (result instanceof Promise) return result.then(r => handleOptionalResult(r, payload.value));
      return handleOptionalResult(result, payload.value);
    }
    if (payload.value === undefined) {
      return payload;
    }
    return def.innerType._zod.run(payload, ctx);
  };
});
export const $ZodNullable = /*@__PURE__*/core.$constructor("$ZodNullable", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
  util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
  util.defineLazy(inst._zod, "pattern", () => {
    const pattern = def.innerType._zod.pattern;
    return pattern ? new RegExp("^(".concat(util.cleanRegex(pattern.source), "|null)$")) : undefined;
  });
  util.defineLazy(inst._zod, "values", () => {
    return def.innerType._zod.values ? new Set([...def.innerType._zod.values, null]) : undefined;
  });
  inst._zod.parse = (payload, ctx) => {
    // Forward direction (decode): allow null to pass through
    if (payload.value === null) return payload;
    return def.innerType._zod.run(payload, ctx);
  };
});
export const $ZodDefault = /*@__PURE__*/core.$constructor("$ZodDefault", (inst, def) => {
  $ZodType.init(inst, def);
  // inst._zod.qin = "true";
  inst._zod.optin = "optional";
  util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      return def.innerType._zod.run(payload, ctx);
    }
    // Forward direction (decode): apply defaults for undefined input
    if (payload.value === undefined) {
      payload.value = def.defaultValue;
      /**
       * $ZodDefault returns the default value immediately in forward direction.
       * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */
      return payload;
    }
    // Forward direction: continue with default handling
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then(result => handleDefaultResult(result, def));
    }
    return handleDefaultResult(result, def);
  };
});
function handleDefaultResult(payload, def) {
  if (payload.value === undefined) {
    payload.value = def.defaultValue;
  }
  return payload;
}
export const $ZodPrefault = /*@__PURE__*/core.$constructor("$ZodPrefault", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.optin = "optional";
  util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      return def.innerType._zod.run(payload, ctx);
    }
    // Forward direction (decode): apply prefault for undefined input
    if (payload.value === undefined) {
      payload.value = def.defaultValue;
    }
    return def.innerType._zod.run(payload, ctx);
  };
});
export const $ZodNonOptional = /*@__PURE__*/core.$constructor("$ZodNonOptional", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "values", () => {
    const v = def.innerType._zod.values;
    return v ? new Set([...v].filter(x => x !== undefined)) : undefined;
  });
  inst._zod.parse = (payload, ctx) => {
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then(result => handleNonOptionalResult(result, inst));
    }
    return handleNonOptionalResult(result, inst);
  };
});
function handleNonOptionalResult(payload, inst) {
  if (!payload.issues.length && payload.value === undefined) {
    payload.issues.push({
      code: "invalid_type",
      expected: "nonoptional",
      input: payload.value,
      inst
    });
  }
  return payload;
}
export const $ZodSuccess = /*@__PURE__*/core.$constructor("$ZodSuccess", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      throw new core.$ZodEncodeError("ZodSuccess");
    }
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then(result => {
        payload.value = result.issues.length === 0;
        return payload;
      });
    }
    payload.value = result.issues.length === 0;
    return payload;
  };
});
export const $ZodCatch = /*@__PURE__*/core.$constructor("$ZodCatch", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
  util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
  util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      return def.innerType._zod.run(payload, ctx);
    }
    // Forward direction (decode): apply catch logic
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then(result => {
        payload.value = result.value;
        if (result.issues.length) {
          payload.value = def.catchValue(_objectSpread(_objectSpread({}, payload), {}, {
            error: {
              issues: result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config()))
            },
            input: payload.value
          }));
          payload.issues = [];
        }
        return payload;
      });
    }
    payload.value = result.value;
    if (result.issues.length) {
      payload.value = def.catchValue(_objectSpread(_objectSpread({}, payload), {}, {
        error: {
          issues: result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config()))
        },
        input: payload.value
      }));
      payload.issues = [];
    }
    return payload;
  };
});
export const $ZodNaN = /*@__PURE__*/core.$constructor("$ZodNaN", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _ctx) => {
    if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
      payload.issues.push({
        input: payload.value,
        inst,
        expected: "nan",
        code: "invalid_type"
      });
      return payload;
    }
    return payload;
  };
});
export const $ZodPipe = /*@__PURE__*/core.$constructor("$ZodPipe", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "values", () => def.in._zod.values);
  util.defineLazy(inst._zod, "optin", () => def.in._zod.optin);
  util.defineLazy(inst._zod, "optout", () => def.out._zod.optout);
  util.defineLazy(inst._zod, "propValues", () => def.in._zod.propValues);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      const right = def.out._zod.run(payload, ctx);
      if (right instanceof Promise) {
        return right.then(right => handlePipeResult(right, def.in, ctx));
      }
      return handlePipeResult(right, def.in, ctx);
    }
    const left = def.in._zod.run(payload, ctx);
    if (left instanceof Promise) {
      return left.then(left => handlePipeResult(left, def.out, ctx));
    }
    return handlePipeResult(left, def.out, ctx);
  };
});
function handlePipeResult(left, next, ctx) {
  if (left.issues.length) {
    // prevent further checks
    left.aborted = true;
    return left;
  }
  return next._zod.run({
    value: left.value,
    issues: left.issues
  }, ctx);
}
export const $ZodCodec = /*@__PURE__*/core.$constructor("$ZodCodec", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "values", () => def.in._zod.values);
  util.defineLazy(inst._zod, "optin", () => def.in._zod.optin);
  util.defineLazy(inst._zod, "optout", () => def.out._zod.optout);
  util.defineLazy(inst._zod, "propValues", () => def.in._zod.propValues);
  inst._zod.parse = (payload, ctx) => {
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
      const left = def.in._zod.run(payload, ctx);
      if (left instanceof Promise) {
        return left.then(left => handleCodecAResult(left, def, ctx));
      }
      return handleCodecAResult(left, def, ctx);
    } else {
      const right = def.out._zod.run(payload, ctx);
      if (right instanceof Promise) {
        return right.then(right => handleCodecAResult(right, def, ctx));
      }
      return handleCodecAResult(right, def, ctx);
    }
  };
});
function handleCodecAResult(result, def, ctx) {
  if (result.issues.length) {
    // prevent further checks
    result.aborted = true;
    return result;
  }
  const direction = ctx.direction || "forward";
  if (direction === "forward") {
    const transformed = def.transform(result.value, result);
    if (transformed instanceof Promise) {
      return transformed.then(value => handleCodecTxResult(result, value, def.out, ctx));
    }
    return handleCodecTxResult(result, transformed, def.out, ctx);
  } else {
    const transformed = def.reverseTransform(result.value, result);
    if (transformed instanceof Promise) {
      return transformed.then(value => handleCodecTxResult(result, value, def.in, ctx));
    }
    return handleCodecTxResult(result, transformed, def.in, ctx);
  }
}
function handleCodecTxResult(left, value, nextSchema, ctx) {
  // Check if transform added any issues
  if (left.issues.length) {
    left.aborted = true;
    return left;
  }
  return nextSchema._zod.run({
    value,
    issues: left.issues
  }, ctx);
}
export const $ZodReadonly = /*@__PURE__*/core.$constructor("$ZodReadonly", (inst, def) => {
  $ZodType.init(inst, def);
  util.defineLazy(inst._zod, "propValues", () => def.innerType._zod.propValues);
  util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
  util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
  util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
  inst._zod.parse = (payload, ctx) => {
    if (ctx.direction === "backward") {
      return def.innerType._zod.run(payload, ctx);
    }
    const result = def.innerType._zod.run(payload, ctx);
    if (result instanceof Promise) {
      return result.then(handleReadonlyResult);
    }
    return handleReadonlyResult(result);
  };
});
function handleReadonlyResult(payload) {
  payload.value = Object.freeze(payload.value);
  return payload;
}
export const $ZodTemplateLiteral = /*@__PURE__*/core.$constructor("$ZodTemplateLiteral", (inst, def) => {
  $ZodType.init(inst, def);
  const regexParts = [];
  for (const part of def.parts) {
    if (typeof part === "object" && part !== null) {
      // is Zod schema
      if (!part._zod.pattern) {
        // if (!source)
        throw new Error("Invalid template literal part, no pattern found: ".concat([...part._zod.traits].shift()));
      }
      const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
      if (!source) throw new Error("Invalid template literal part: ".concat(part._zod.traits));
      const start = source.startsWith("^") ? 1 : 0;
      const end = source.endsWith("$") ? source.length - 1 : source.length;
      regexParts.push(source.slice(start, end));
    } else if (part === null || util.primitiveTypes.has(typeof part)) {
      regexParts.push(util.escapeRegex("".concat(part)));
    } else {
      throw new Error("Invalid template literal part: ".concat(part));
    }
  }
  inst._zod.pattern = new RegExp("^".concat(regexParts.join(""), "$"));
  inst._zod.parse = (payload, _ctx) => {
    if (typeof payload.value !== "string") {
      payload.issues.push({
        input: payload.value,
        inst,
        expected: "template_literal",
        code: "invalid_type"
      });
      return payload;
    }
    inst._zod.pattern.lastIndex = 0;
    if (!inst._zod.pattern.test(payload.value)) {
      var _def$format;
      payload.issues.push({
        input: payload.value,
        inst,
        code: "invalid_format",
        format: (_def$format = def.format) !== null && _def$format !== void 0 ? _def$format : "template_literal",
        pattern: inst._zod.pattern.source
      });
      return payload;
    }
    return payload;
  };
});
export const $ZodFunction = /*@__PURE__*/core.$constructor("$ZodFunction", (inst, def) => {
  $ZodType.init(inst, def);
  inst._def = def;
  inst._zod.def = def;
  inst.implement = func => {
    if (typeof func !== "function") {
      throw new Error("implement() must be called with a function");
    }
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const parsedArgs = inst._def.input ? parse(inst._def.input, args) : args;
      const result = Reflect.apply(func, this, parsedArgs);
      if (inst._def.output) {
        return parse(inst._def.output, result);
      }
      return result;
    };
  };
  inst.implementAsync = func => {
    if (typeof func !== "function") {
      throw new Error("implementAsync() must be called with a function");
    }
    return async function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      const parsedArgs = inst._def.input ? await parseAsync(inst._def.input, args) : args;
      const result = await Reflect.apply(func, this, parsedArgs);
      if (inst._def.output) {
        return await parseAsync(inst._def.output, result);
      }
      return result;
    };
  };
  inst._zod.parse = (payload, _ctx) => {
    if (typeof payload.value !== "function") {
      payload.issues.push({
        code: "invalid_type",
        expected: "function",
        input: payload.value,
        inst
      });
      return payload;
    }
    // Check if output is a promise type to determine if we should use async implementation
    const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
    if (hasPromiseOutput) {
      payload.value = inst.implementAsync(payload.value);
    } else {
      payload.value = inst.implement(payload.value);
    }
    return payload;
  };
  inst.input = function () {
    const F = inst.constructor;
    if (Array.isArray(arguments.length <= 0 ? undefined : arguments[0])) {
      return new F({
        type: "function",
        input: new $ZodTuple({
          type: "tuple",
          items: arguments.length <= 0 ? undefined : arguments[0],
          rest: arguments.length <= 1 ? undefined : arguments[1]
        }),
        output: inst._def.output
      });
    }
    return new F({
      type: "function",
      input: arguments.length <= 0 ? undefined : arguments[0],
      output: inst._def.output
    });
  };
  inst.output = output => {
    const F = inst.constructor;
    return new F({
      type: "function",
      input: inst._def.input,
      output
    });
  };
  return inst;
});
export const $ZodPromise = /*@__PURE__*/core.$constructor("$ZodPromise", (inst, def) => {
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, ctx) => {
    return Promise.resolve(payload.value).then(inner => def.innerType._zod.run({
      value: inner,
      issues: []
    }, ctx));
  };
});
export const $ZodLazy = /*@__PURE__*/core.$constructor("$ZodLazy", (inst, def) => {
  $ZodType.init(inst, def);
  // let _innerType!: any;
  // util.defineLazy(def, "getter", () => {
  //   if (!_innerType) {
  //     _innerType = def.getter();
  //   }
  //   return () => _innerType;
  // });
  util.defineLazy(inst._zod, "innerType", () => def.getter());
  util.defineLazy(inst._zod, "pattern", () => inst._zod.innerType._zod.pattern);
  util.defineLazy(inst._zod, "propValues", () => inst._zod.innerType._zod.propValues);
  util.defineLazy(inst._zod, "optin", () => {
    var _inst$_zod$innerType$;
    return (_inst$_zod$innerType$ = inst._zod.innerType._zod.optin) !== null && _inst$_zod$innerType$ !== void 0 ? _inst$_zod$innerType$ : undefined;
  });
  util.defineLazy(inst._zod, "optout", () => {
    var _inst$_zod$innerType$2;
    return (_inst$_zod$innerType$2 = inst._zod.innerType._zod.optout) !== null && _inst$_zod$innerType$2 !== void 0 ? _inst$_zod$innerType$2 : undefined;
  });
  inst._zod.parse = (payload, ctx) => {
    const inner = inst._zod.innerType;
    return inner._zod.run(payload, ctx);
  };
});
export const $ZodCustom = /*@__PURE__*/core.$constructor("$ZodCustom", (inst, def) => {
  checks.$ZodCheck.init(inst, def);
  $ZodType.init(inst, def);
  inst._zod.parse = (payload, _) => {
    return payload;
  };
  inst._zod.check = payload => {
    const input = payload.value;
    const r = def.fn(input);
    if (r instanceof Promise) {
      return r.then(r => handleRefineResult(r, payload, input, inst));
    }
    handleRefineResult(r, payload, input, inst);
    return;
  };
});
function handleRefineResult(result, payload, input, inst) {
  if (!result) {
    var _inst$_zod$def$path;
    const _iss = {
      code: "custom",
      input,
      inst,
      // incorporates params.error into issue reporting
      path: [...((_inst$_zod$def$path = inst._zod.def.path) !== null && _inst$_zod$def$path !== void 0 ? _inst$_zod$def$path : [])],
      // incorporates params.error into issue reporting
      continue: !inst._zod.def.abort
      // params: inst._zod.def.params,
    };
    if (inst._zod.def.params) _iss.params = inst._zod.def.params;
    payload.issues.push(util.issue(_iss));
  }
}